<template>
    <button class="btn btn-primary btn-edge" disabled>
        Zpracovává se
    </button>
</template>

<script>
import axios from "axios";

export default {
    name: "status-checker",

    props: ['route', 'documentType', 'documentIdent'],

    data: function() {
        return {
            interval: null,
        }
    },

    mounted: function () {
        let self = this
        let idents = JSON.parse(self.documentIdent)
        self.identsStatus = {};
        let successCount = 0;

        for (let ident in idents) {
            self.identsStatus[idents[ident]] = 'waiting';
        }

        this.interval = setInterval(function () {
            successCount = 0;
            for (let ident in idents) {
                if (self.identsStatus[idents[ident]] != "success") {
                    self.call(self, idents[ident])
                } else {
                    successCount++
                }
            }

            if (successCount === idents.length) {
                self.interval = null
                location.reload();
            }
        }, 4000)
    },

    methods: {
        call: function (self, ident) {
            let axios = require('axios')

            let config = {
                method: 'get',
                url: self.route,
                params: {
                    document_type: self.documentType,
                    document_ident: ident
                },
                headers: { }
            };

            axios(config)
                .then(function (response) {
                    if (response.data.status == "success") {
                        self.identsStatus[ident] = "success";
                    }
                })
                .catch(function (error) {
                    self.interval = null
                })
        }
    }
}
</script>

<style scoped>
</style>
